import * as actionTypes from '../actions/actionTypes';

const initState = {
  currentCase:{
    status: "Unkown"
  },
  showActionModal: false,
  caseStatus:undefined
};

export default function darkTitlebarReducer(state = initState, action) {
  switch(action.type){
    case actionTypes.SET_DARK_TITLEBAR_CONTENT: {
      let {pageTitle, showActionbutton, actionButtontext, actionButtonIcon, currentCase, caseStatus} = action;
      if(currentCase === undefined) {
        currentCase = state.currentCase;
      }
      if(caseStatus === undefined) {
        caseStatus = state.caseStatus;
      }
      return {pageTitle, showActionbutton, actionButtontext, actionButtonIcon, currentCase,caseStatus};
    }
    case actionTypes.HIDE_ACTION_BUTTON: {
      let dTitlebar = {...state};
      return {...dTitlebar, showActionbutton: undefined};
    }
    case actionTypes.SET_DARK_TITLE_CURRENT_CASE: {
      let dTitlebar = {...state};
      return {...dTitlebar, currentCase: action.currentCase};
    }
    case actionTypes.UPDATE_DARK_TITLE_BAR_CASE_STATUS: {
      let _currentCase = {...state.currentCase};
      _currentCase.status = action.caseStatus;
      return {...state, currentCase: _currentCase};
    }
    case actionTypes.SHOW_DARK_TITLE_BAR_ACTION_MODAL: {
      return {...state, showActionModal: true};
    }
    case actionTypes.HIDE_DARK_TITLE_BAR_ACTION_MODAL: {
      return {...state, showActionModal: false};
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layouts/reducers/darkTitleBarReducer.js